import { render } from "./CustomersDashboard.vue?vue&type=template&id=5c4aea66"
import script from "./CustomersDashboard.vue?vue&type=script&lang=js"
export * from "./CustomersDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/home/desarollo2/Documents/GitHub/dicora-customers-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__